import { useState, useEffect } from 'react';
import { AuthTabs } from '../components/Auth/AuthTabs/AuthTabs';
import { LoginForm } from '../components/Auth/LoginForm/LoginForm';
import { SignUpForm } from '../components/Auth/SignUpForm/SignUpForm';
import { useAuth } from '../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import fetchWithAuth from '../utils/fetchWithAuth';

const Auth = () => {
  console.log('🔍 Auth component mounted, hash =', window.location.hash);
  const [activeTab, setActiveTab] = useState(0); // 0 = login, 1 = signup
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
  const checkOnboardingStatus = async () => {
    if (user && user.emailVerified) {
      try {
        const userData = await fetchWithAuth('/api/users/me');
        const force = localStorage.getItem('forceOnboarding') === 'true';

        if (userData.onboardingCompleted || force) {
          navigate('/app/home', { replace: true });
        } else {
          navigate('/app/onboarding', { replace: true });
        }
      } catch (error) {
        console.error('Failed to fetch onboarding status:', error);
        navigate('/app/home', { replace: true });
      }
    }
  };

  checkOnboardingStatus();
}, [user, navigate]);

  return (
    <div className="background-light-primary min-h-screen flex items-center justify-center px-4">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-sm px-6 py-4 pt-2 relative z-10">
        <AuthTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        {activeTab === 0 && <LoginForm />}
        {activeTab === 1 && <SignUpForm />}
        <div className="text-xs text-gray-500 text-center mt-6">
          <Link to="/privacy" className="underline">
            Privacy Policy
          </Link>
          <span className="mx-2">|</span>
          <Link to="/terms" className="underline">
            Terms of Service
          </Link>
          <span className="mx-2">|</span>
          <Link to="/imprint" className="underline">
            Imprint
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Auth;
